// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"9e00b47901036a88a19b","780":"5512fa2ec4dd1eaaede9","838":"31ef7182d9bf8a547959"}[chunkId] + ".js";
};